import { forwardRef } from 'react';
import { Info, Close } from '@mui/icons-material';
import { Paper, Stack, Typography, IconButton } from '@mui/material';
import { CustomContentProps, useSnackbar, SnackbarContent } from 'notistack';

export const BannerNotification = forwardRef<
  HTMLDivElement,
  CustomContentProps
>((props, ref) => {
  const { id, message, ...other } = props;
  const { closeSnackbar } = useSnackbar();

  const handleDismiss = () => {
    closeSnackbar(id);
  };

  if (typeof message !== 'string' || !message || message === 'none') {
    return null;
  }

  return (
    <SnackbarContent ref={ref} role="alert" {...other}>
      <Paper
        sx={{
          position: 'relative',
          display: 'flex',
          gap: 3,
          width: '100%',
          minWidth: '640px',
          maxWidth: '1024px',
          padding: '16px',
          backgroundColor: '#148def',
          color: 'white',
        }}
      >
        <Info sx={{ color: 'white' }} />

        <Stack flex={1} gap={1.25}>
          <Typography variant="body2" fontWeight="bold">
            Important Notice
          </Typography>
          <Typography
            variant="body2"
            component="div"
            dangerouslySetInnerHTML={{ __html: message }}
          />
        </Stack>

        <IconButton
          size="small"
          onClick={handleDismiss}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'white',
          }}
        >
          <Close fontSize="small" />
        </IconButton>
      </Paper>
    </SnackbarContent>
  );
});
